//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { FactoryUtils } from "@/utils/FactoryUtils" 
    export default {
        name: "illustrate",
        data(){
            return {
                infoArr:[],
            }
        },
        components:{
          
        },
        created() {
          if(FactoryUtils.getInstructions()){
            FactoryUtils.getInstructions().then(res =>{
              this.infoArr = res.insure
            })
          }
          
        },
        mounted(){
           
        },
        computed: {
          templateFlag(){
            return this.$route.query.templateFlag
          }
        },
        methods:{
            goPersonal(){
              this.STATISTICS('click','sybao_ins_proinfo_apnt_click')
                this.$router.push({
                    path:'/personal'
                })
            }
        }
    }
